import Cookies from "js-cookie";
import { firebase } from '../firebase/firebase';

export const authfxLogout = () => {
    const ssoToken = Cookies.get('authFxToken', { path: '/', domain: '.authfx.io' })
    if (ssoToken) {
        const requestOptions = {
            method: 'POST',
            headers: { 
                'Accept-API-Version': 'resource=3.1, protocol=1.0',
                'authFxToken': ssoToken
            }
        };
        fetch('https://app-dev.authfx.io/auth/json/realms/root/realms/authfx/sessions/?_action=logout', requestOptions);
    }
};

export const authfxUserinfo = (token) => {
    return dispatch => {
        const requestOptions = {
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + token,
          }
        };
        fetch(
          'https://app-dev.authfx.io/auth/oauth2/realms/root/realms/authfx/userinfo',
          requestOptions
        )
          .then((response) => response.json())
          .then((data) => {
            firebase
              .auth()
              .currentUser.updateProfile({ 
                displayName: data.name,
                photoURL: data.picture 
              })
              dispatch({ type: 'USERINFO', userinfo: data })
          })
          .catch((error) => console.error('Fetching data failed', error))
    }
};


// WEBPACK FOOTER //
// ./src/actions/authfx.js